import React, { useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography
} from "@mui/material";

//Material Icons
import { Add, Cancel, PersonAdd } from "@mui/icons-material";

//Helpers
import { countries } from "../../Helpers/countries";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

export default function SetClientDrawer({
  isNewClient = true,
  existingClientData = {},
  open,
  setOpen,
  getData,
}) {
  // ==========>Component States<==========
  //State for userData
  const [clientData, setClientData] = useState({
    name: existingClientData.name || "",
    type: existingClientData.type || 3,
    idDocument: existingClientData.idDocument || "",
    phoneNumber: existingClientData.phoneNumber || "",
    email: existingClientData.email || "",
    address: existingClientData.address || "",
    province: existingClientData.province || "",
    country: countries.indexOf(existingClientData.country) || 5,
  });
  //State for setting loader
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  //Form to add new client
  const addClientForm = [
    {
      selection: "textfield",
      id: "name",
      initialValue: clientData.name,
      xs: 12,
      md: 4,
      label: "Nombre del cliente",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre del cliente",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "type",
      initialValue: clientData.type,
      xs: 12,
      md: 4,
      label: "Tipo de identificación",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Nacionalidad",
      content: ["Física", "Jurídica", "Otra", "Sin asignar"],
      style: { minWidth: "100%" },
    },
    {
      selection: "textfield",
      id: "idDocument",
      initialValue: clientData.idDocument,
      xs: 12,
      md: 4,
      label: "Número de identificación",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número de identificación",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "phoneNumber",
      initialValue: clientData.phoneNumber,
      xs: 12,
      md: 4,
      label: "Número de teléfono",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número de teléfono",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "email",
      initialValue: clientData.email,
      xs: 12,
      md: 4,
      label: "Correo electrónico",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Correo electrónico",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "address",
      initialValue: clientData.address,
      xs: 12,
      md: 4,
      label: "Dirección",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Dirección y otras señas",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "province",
      initialValue: clientData.province,
      xs: 12,
      md: 4,
      label: "Provincia/Estado",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Provincia/Estado",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "country",
      initialValue: clientData.country,
      xs: 12,
      md: 4,
      label: "País",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "País",
      content: countries,
      style: { minWidth: "100%" },
    },
  ];

  // ==========>Component Functions<==========
  //Function to create new user
  const setClient = async () => {
    setIsLoading(true);

    const newClient = {
      clientId: existingClientData.id,
      name: clientData.name,
      type: clientData.type,
      idDocument: clientData.idDocument,
      phoneNumber: clientData.phoneNumber,
      email: clientData.email,
      address: clientData.address,
      province: clientData.province,
      country: countries[clientData.country],
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        isNewClient ? "/clients/create" : "/clients/edit-client",
        newClient
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText(
          isNewClient
            ? "Cliente registrado exitosamente."
            : "Cliente editado exitosamente."
        );
        setModalDescription(jsonResponse.description);
        getData();
        setOpen(false);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <PersonAdd color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            {isNewClient ? `Nuevo cliente` : `Editar información del cliente`}
          </Typography>
         
        </Grid>
        <Grid item xs={12}>
          <Form data={addClientForm} handleStateChange={setClientData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={clientData.name === ""}
                onClick={setClient}
              >
                {isNewClient ? "Registrar cliente" : "Guardar cambios"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
